export default {
  "ORDER_WAIT_SHIP": "Ожидает отправки",
  "Men fashion": "Мужская мода",
  "MyAccount_MyProfile_label_First": "Имя",
  "MyAccount_MyShippingDetails_Phone": "Телефон",
  "Page_not_found_message1": "Извините, страница не найдена",
  "Help": "Помощь",
  "Sign in": "Вход",
  "Register": "Регистрация",
  "Category_sorting_Item": "Выберите способ сортировки",
  "cart_clear": "Очистить корзину",
  "Payment & Delivery": "Оплата и доставка",
  "Send my feedback": "Отправить мои отзывы",
  "MyAccount_MyProfile_Save": "Сохранить изменения",
  "Continue_billing": "Продолжить оплату",
  "Categories": "Категории",
  "Read and understand": "Я прочитал и согласен",
  "Feel free to edit": "В любое время редактируйте свою информацию, чтобы ваша учетная запись всегда была актуальной",
  "Select payment method": "Выберите способ оплаты",
  "Login_input_email": "Ваш e-mail",
  "Login_input_first": "Имя",
  "Account": "Аккаунт",
  "Create_Time_Asc": "Время создания по возрастанию",
  "concactus_label": "Вопросы или идеи",
  "Order_Grade": "Оценка заказа",
  "wishlist_empty_desc": "Похоже, вы еще не добавили никаких товаров в свою корзину. Начните покупки!",
  "cartpreviewShipping_messageinfo": "Мы сообщим вам о подтверждении отправки и уточним дату доставки",
  "unsubscribe": "Вы можете отказаться от подписки в любое время",
  "prompt": "Подсказка",
  "MyAccount_MyProfile_yinsi_message": "Brand name строго соблюдает правила конфиденциальности и защиты персональных данных своих пользователей. Более подробная информация о том, как мы заботимся и используем вашу личную информацию, содержится в разделе с",
  "About us": "О нас",
  "or": "или",
  "MyAccount_Order_History_All": "Все заказы",
  "What_We_Improve": "Что мы улучшаем?",
  "MyAccount_ShippingDetails_title": "Детали доставки",
  "MyAccount_Order_History_Tabs2": "Ожидают оплаты",
  "Go_back_shopping": "Вернуться к покупкам",
  "Product": "Продукт",
  "Order summary": "Итог заказа",
  "payment_order_total": "Общая сумма заказа",
  "Departments": "Отделы",
  "Download": "Загрузить",
  "Your_Purchase_Order": "Ваш заказ",
  "Your_Account": "Ваш аккаунт",
  "order_after_sales_list_null": "У вас нет заказов на послепродажное обслуживание",
  "All_After_sales_orders": "Все заказы на послепродажное обслуживание",
  "Filters": "Фильтры",
  "search_results_not": "Мы не нашли результаты, соответствующие вашему запросу",
  "ORDER_WAIT_RECEIPT": "Ожидает получения",
  "ORDER_CLOSED": "Закрыт",
  "Order_View_details": "Посмотреть детали",
  "Subscribe_to_message": "Будьте в курсе грядущих распродаж и акций. Получайте подарки и эксклюзивные предложения!",
  "TaxFee": "Налоги",
  "Apply": "Применить",
  "Total_price": "Итоговая цена",
  "Description": "Описание",
  "Payment method": "Способ оплаты",
  "Back": "Назад",
  "Empty": "Похоже, вы еще не добавили никаких товаров в свою корзину. Начните покупки, чтобы наполнить ее.",
  "After_sales": "Послепродажное обслуживание",
  "Instruction3": "Да, мы знаем",
  "MyAccount_MyShippingDetails_Last": "Фамилия",
  "MyAccount_MyShippingDetails_City": "Город",
  "payment_order_discount": "Скидка на заказ",
  "MyAccount_Order": "Информация о заказе",
  "ID_Name_Error": "Введите свое имя, указанное в удостоверении личности",
  "Kidswear": "Детская мода",
  "Share your look": "Поделитесь своим образом",
  "Pay_Order": "Оплатить заказ",
  "Reset_Password": "Сбросить пароль",
  "MyAccount_MyProfile_label2_pass1": "Текущий пароль",
  "Create_Time_Desc": "Время создания по убыванию",
  "Items": "Товары",
  "Login_Register": "Зарегистрироваться",
  "Back to homepage": "Вернуться на домашнюю страницу",
  "switch_CNY": "Переключить на юани",
  "Successful placed order": "Вы успешно оформили заказ. Вы можете проверить состояние заказа, используя нашу функцию отслеживания доставки. Вам будет отправлено письмо-подтверждение заказа со всей необходимой информацией и ссылкой для отслеживания.",
  "MyAccount_MyProfile_yinsi_link": "Политика конфиденциальности",
  "Order_Date": "Дата заказа",
  "Allow order notifications": "Разрешить уведомления о заказах",
  "MyAccount_MyProfile_Tab1": "Мой профиль",
  "MyAccount_ShippingDetails_changeTitle": "Изменить адрес",
  "ID_Number": "ИНН",
  "Order_after_sales_message": "Детали заказа и послепродажной обработки",
  "MyAccount_MyProfile_title2": "Если вы хотите изменить пароль для доступа к своей учетной записи, введите следующую информацию:",
  "Customer service": "Служба поддержки клиентов",
  "MyAccount_MyProfile_Update": "Обновить пароль",
  "choose_language": "Выберите язык",
  "ORDER_REFUNDING": "Возврат средств",
  "MyAccount_MyProfile_title1": "В любое время редактируйте информацию ниже, чтобы ваша учетная запись была всегда актуальной.",
  "ORDER_WAIT_RATE": "Ожидает оценки",
  "after_sales_refund_order": "Возврат заказа",
  "Who we are": "О нас",
  "Women fashion": "Женская мода",
  "Personal details": "Персональные данные",
  "Password": "Пароль",
  "wishlist_empty_title": "В вашей корзине нет товаров",
  "Repeat_Password": "Повторите пароль",
  "cart_price": "Итого",
  "Sort_by": "Сортировка по",
  "Customer Reviews": "Отзывы клиентов",
  "Continue to shipping": "Продолжить с доставкой",
  "payment_make_order": "Оформить заказ",
  "save_order_review": "Отправить отзыв о товаре",
  "Save_Password": "Сохранить пароль",
  "cart_empty_title": "Ваша корзина пуста",
  "TopBar_help": "Помощь и часто задаваемые вопросы",
  "colseCookie": "Я понимаю",
  "Password_Changed": "Пароль был успешно изменен. Можно вернуться на главную страницу и войти.",
  "Forgot Password Modal Email": "Ваш адрес электронной почты, который вы использовали для входа:",
  "MyAccount_Personal": "Персональные данные",
  "cartPreviewShipping": "Удобная доставка",
  "ORDER_AFTER_SALE": "Послепродажное обслуживание",
  "Page_not_found": "Страница не найдена",
  "Find out more": "Узнать больше",
  "Log into your account": "Войти в свой аккаунт",
  "Details_and_status_orders": "Просмотрите информацию и статус заказов онлайн-магазина. Вы также можете отменить заказ или запросить возврат.",
  "Order_to_be_paid_message": "Ожидание оплаты",
  "Guarantee": "Гарантия",
  "Sections that interest you": "Ваши интересы",
  "payment_post_tax": "Налоги и комиссии",
  "ORDER_PAID": "Оплачен",
  "concactus_label5": "Обращение",
  "Item": "Товар",
  "Go_back": "Вернуться",
  "more": "Больше",
  "MyAccount": "Мой аккаунт",
  "payment_agree_1": "Я согласен(на)",
  "total_items": "Итоговое количество",
  "shopping_go": "Управлять адресами доставки",
  "ID_Type": "Тип удостоверения личности",
  "after_sales_status": "Статус послепродажного обслуживания",
  "After_sales_apply": "Подать заявку на послепродажное обслуживание",
  "Login": "Войти",
  "Quantity": "Количество",
  "payment_post_fee": "Почтовые расходы",
  "MyAccount_Log_out": "Выйти из аккаунта",
  "Subtotal": "Промежуточный итог",
  "forgotPasswordConfirmation": "Спасибо! Если аккаунт был зарегистрирован на {0} электронной почте, вы найдете сообщение с ссылкой для сброса пароля во входящих сообщениях.",
  "MyAccount_Order_History_Tabs1": "Мои заказы",
  "concactus_img": "Загрузить изображение",
  "Done": "Готово",
  "Info after order": "Вы можете войти в свой аккаунт с помощью указанной ранее электронной почты и пароля. В своём аккаунте вы сможете редактировать свои персональные данные, просматривать историю ваших покупок, редактировать подписки на новостную рассылку и т.д.",
  "MyAccoubnt_Set_newsletter": "Настройте свой еженедельный бюллетень, чтобы получать информацию о новых продуктах и тенденциях. ",
  "Shipping_method": "Способ доставки",
  "after_sales_refund": "Сумма возврата",
  "After_sales_save": "Сохранить информацию о послепродажном обслуживании",
  "go_order_history": "Перейти к истории заказов",
  "contactus_message_placeholder": "Напишите свой комментарий или вопрос",
  "Login_Forgot_Password": "Если вы не можете вспомнить свой пароль, вы можете сбросить его.",
  "show_more": "Показать больше",
  "MyAccount_MyProfile_label_email": "Ваш адрес электронной почты",
  "MyAccount_MyProfile_label2_pass3": "Повторите пароль",
  "Products": "Продукты",
  "Review": "Обзор",
  "MyAccount_MyProfile_title3": "Ваш текущий адрес электронной почты",
  "Category_found_Products": "Найденные продукты в категории",
  "Match": "Спаривание",
  "Read_all_reviews": "Читать все отзывы",
  "Commercial information": "Я согласен(на) получать персонализированную коммерческую информацию от пользовательского имени по электронной почте.",
  "Change password your account": "Если вы хотите изменить пароль доступа к аккаунту, укажите следующую информацию",
  "ID_Name": "ФИО, указанные в удостоверении личности",
  "All": "Все",
  "Instruction2": "Вам нужны только инструкции по уходу?",
  "MyAccount_ShippingDetails_Add": "Добавить новый адрес",
  "MyAccount_MyShippingDetails_Zip": "Почтовый индекс",
  "go_pay_order": "Оплатить заказ",
  "Thank_You_Inbox": "Если вы не нашли сообщение во входящих, попробуйте использовать другой адрес электронной почты, который вы использовали для регистрации.",
  "Subscribe": "Подписаться",
  "confirm_subscription": "Я подтверждаю, что я хочу подписаться на рассылки",
  "Login_input_Remember": "Запомнить меня",
  "Add to compare": "Добавить в сравнение",
  "Brand": "Бренд",
  "Start_shopping": "Начать покупку",
  "Select shipping method": "Выбрать метод доставки",
  "address CN": "Если ваш адрес находится в Китае, валюта должна быть юань",
  "MyAccount_MyShippingDetails_State": "Район/область",
  "Page_not_found_message2": "Вернитесь или попробуйте еще раз",
  "Go_to_checkout": "Оформить заказ",
  "See all results": "Показать все результаты",
  "search_results_inputnull": "Вы еще не искали ни одного товара.",
  "subscribeToNewsletterModalContent": "Подпишитесь на рассылку, чтобы получать специальные предложения и информацию от VSF по электронной почте. Мы никогда не продадим или не передадим вашу электронную почту третьим лицам. Пожалуйста, ознакомьтесь с нашей {0}.",
  "Download all": "Скачать все",
  "Login_input_last": "Фамилия",
  "Amount": "Сумма",
  "ORDER_WAIT_PAYMENT": "В ожидании оплаты",
  "Order_After_sales": "заказ после продаж",
  "concattus_button": "Отправить",
  "Shipping_valid_required": "Это поле обязательно",
  "Price": "Цена",
  "ID_Type_Error": "Выберите тип вашего удостоверения личности",
  "Order_Status": "Статус заказа",
  "Payment methods": "Способы оплаты",
  "MyAccount_MyProfile_Tab2": "Изменить пароль",
  "Show on page": "Отображать на странице",
  "Edit": "Редактировать",
  "Change": "Изменить",
  "MyAccount_ShippingDetails_Update": "Обновить адрес",
  "View": "Просмотр",
  "Privacy": "Конфиденциальность",
  "Enter_promo_code": "Введите промо-код",
  "Discount": "Скидка",
  "Delete": "Удалить",
  "Wishlist": "Список пожеланий",
  "MyAccount_Order_History_Tabs3": "Возврат",
  "Go_To_Order_review": "Перейти к отзыву",
  "Update personal data": "Обновить личные данные",
  "payment_agree_2": "Условия и положения",
  "or fill the details below": "Или заполните детали ниже",
  "Contact details updated": "Обновляйте свой адрес и данные для связи. ",
  "Login_Create": "Создать аккаунт",
  "Payment": "Оплата",
  "Billing": "Выставление счета",
  "payment_insurance_tax": "Страховой налог",
  "Size guide": "Руководство по размерам",
  "Login_forgotten_password": "Забыли пароль?",
  "Login_no_account": "Нет аккаунта?",
  "Privacy_Policy": "Политика конфиденциальности",
  "BootomCookieTitle": "Разрешение на куки-файлы",
  "Use your personal data": "В Бренд-нейм мы очень серьезно относимся к вопросам конфиденциальности и стремимся защитить личные данные наших пользователей. Чтобы узнать больше о том, как мы заботимся и используем ваши личные данные, ознакомьтесь с ",
  "Review my order": "Мой заказ",
  "BootomCookieLink": "Узнать больше",
  "hide": "Скрыть",
  "MyAccount_ShippingDetails_message_title": "Управляйте всеми своими адресами доставки (рабочий, домашний и т. д.), чтобы не вводить их вручную при каждом заказе. ",
  "Purchase terms": "Условия покупки",
  "Billing_address": "Адрес выставления счета",
  "Manage shipping addresses": "Управляйте всеми своими адресами доставки (рабочий, домашний и т. д.), чтобы не вводить их вручную при каждом заказе. ",
  "login_logbtn": "Войти в аккаунт",
  "choose_currency": "Выберите валюту",
  "ORDER_REFUNDED": "Возвращенный заказ",
  "After_sales_form": "Заполните форму по продажам",
  "add_To_Wishlist": "Добавить в список пожеланий",
  "search_results_inputnull2": "Начните сейчас, мы вам поможем.",
  "Total": "Всего",
  "Subscribe_to_newsletter": "Подписаться на новости",
  "Shipping_valid_Phone": "Введите действительный номер телефона",
  "concactus_label3": "Название",
  "Manage billing addresses": "Управляйте всеми своими адресами выставления счета (рабочий, домашний и т. д.), чтобы не вводить их вручную при каждом заказе. ",
  "Search_results_title": "Результаты поиска",
  "payment_order_payment": "Оплата заказа",
  "after_sales_Id": "ID по продажам",
  "cart_title": "Моя корзина",
  "Order_Detail": "Детали заказа",
  "concactus_label2": "Ссылка на магазин",
  "Shipping_valid_length_min": "Должно содержать по крайней мере {min} символов",
  "Product suggestions": "Предложения продуктов",
  "Return_home": "На главную",
  "Quality in the details": "Качество в деталях",
  "Continue_to_payment": "Продолжить оплату",
  "Feedback": "Ваш отзыв для нас очень важен. Пожалуйста, скажите нам, что мы можем улучшить.",
  "Go back to shop": "Назад в магазин",
  "Back_to_home": "Вернуться на главную",
  "Review_Content": "Содержание отзыва",
  "add_To_Cart": "Добавить в корзину",
  "Read_reviews": "Читать отзывы",
  "Instruction1": "Инструкции по уходу",
  "Email_address": "Электронный адрес",
  "Category_Item_List": "Переключить на список",
  "Same as shipping address": "То же, что и адрес доставки",
  "Category_Item_Grid": "Переключить на сетку",
  "ID_Number_Error": "Введите свой номер удостоверения личности",
  "concactus_label4": "Электронная почта контакта",
  "Additional_info": "Дополнительная информация",
  "add_shipping": "Добавить новый адрес доставки",
  "Product_description": "Футболка Karissa V-Neck Tee имеет полуприлегающий дизайн, который подходит для любой фигуры. Она облегает тело, скрывает «проблемные» области и позволяет вам чувствовать себя уверенно в спортзале. А также удивительные женские коктейльные платья и вечерние",
  "Login_create_account": "Создать аккаунт",
  "after_sales_Reason": "Причина продажи",
  "MyAccount_MyProfile_label_Last": "Фамилия",
  "MyAccount_MyProfile_label2_pass2": "Новый пароль",
  "Save": "Сохранить",
  "CartSliderTextBtn": "Сохранить для покупки позже",
  "Color": "Цвет",
  "Shipping_Tax": "Налог на доставку",
  "Subscribe_to_success": "Вы успешно подписались",
  "Enjoy your free account": "Наслаждайтесь преимуществами вашей бесплатной учетной записи!",
  "cart_empty_desc": "Пока что вы не добавили ни одного товара в корзину. Начните покупать, чтобы наполнить ее.",
  "MyAccount_ShippingDetails_message_title2": "Обновляйте свой адрес и данные для связи.",
  "An_error_occured": "Произошла ошибка",
  "Country": "Страна",
  "MyAccount_MyShippingDetails_First": "Имя",
  "payment_insurance_fee": "Страховая плата",
  "Home": "Главная страница",
  "Contact_us": "Свяжитесь с нами",
  "Cookies Policy": "Политика использования cookie",
  "Clear all": "Очистить всё",
  "Basket": "Корзина",
  "MyAccount_MyProfile_reqeatPassErrMsg": "Новый пароль не совпадает",
  "Your current email address is": "Ваш текущий адрес электронной почты:",
  "You currently have no orders": "У вас пока нет заказов",
  "Login_input_password": "Пароль",
  "Promo_code": "Промо-код",
  "order_count": "Количество заказов",
  "email_geshi_error": "Пожалуйста, введите действительный адрес электронной почты",
  "your_email": "Ваш электронный адрес",
  "email": "Электронная почта",
  "you_have_subscribed": "Вы подписаны",
  "cancel_Subscribe": "Отменить подписку",
  "save_and_pay": "Сохранить и оплатить",
  "hasInsurance": "Купить страховку?",
  "pleasePayType": "Выберите способ оплаты",
  "zhuanfa_toBePay": "Передать другу для оплаты",
  "linkCopied": "Ссылка скопирована. Поделитесь с друзьями!",
  "Links": "Ссылки",
  "article_category": "Категория статьи",
  "wechat_code_login_message": "Пожалуйста, используйте WeChat для сканирования QR-кода и входа в систему",
  "wechat_code_login": "Вход с помощью сканирования WeChat",
  "Api_Update_success": "Обновление прошло успешно",
  "Please_Use_WeChat_login": "Пожалуйста, используйте WeChat для входа в систему",
  "mobile_geshi_error": "Введите действительный номер мобильного телефона",
  "Login_input_email_required": "Введите адрес электронной почты",
  "article_null": "Нет статьей",
  "Login_with_microsoft": "Вход с помощью Microsoft",
  "article_null_des": "Вы можете просматривать статьи в других категориях",
  "register_email": "Регистрация по электронной почте",
  "Login_tab_email": "Вход по электронной почте",
  "code.time": "{time} секунд до повторной попытки",
  "Login_with_wechat": "Вход с помощью WeChat",
  "cat_items_null_des": "Вы можете просмотреть товары в других категориях",
  "Login_with_facebook": "Вход с помощью Facebook",
  "Login_input_code": "Код подтверждения",
  "Login_input_mobile_required": "Введите номер мобильного телефона",
  "Login_input_mobile": "Введите ваш номер мобильного телефона",
  "cat_items_null": "В этой категории нет товаров",
  "Login_with_twitter": "Вход с помощью Twitter",
  "mobile_code": "Код подтверждения",
  "register_mobile": "Регистрация по мобильному телефону",
  "Login_tab_mobile": "Вход по мобильному телефону",
  "Login_with_google": "Вход с помощью Google",
  "OrderSku": "Спецификация товара",
  "Order_logisticsNo": "Номер логистики",
  "order_shopping_firstname": "Имя",
  "Order_logisticsName": "Логистическая компания",
  "ItemPrice": "Стоимость товара",
  "inPayOrderAll": "Список ожидающих оплаты",
  "payPrice": "Сумма оплаты",
  "shipping_add_success": "Адрес доставки создан успешно",
  "match_goods": "Горячие товары",
  "pay_code_refresh": "Обновить платежный код",
  "pay_code_shixiao": "QR-код оплаты недействителен",
  "concactus_title": "Связаться с нами",
  "Search_items": "Поиск",
  "WebAutoLang": "Ваш браузер рекомендует язык: {lang}. Хотели бы вы переключиться на этот язык?",
  "Services_Name": "Название услуги",
  "Services_Price": "Стоимость услуги",
  "SwichLang": "Сменить язык",
  "Services_Description": "Описание услуги",
  "goodinfo_null": "Нет товара",
  "goodinfo_null_des": "Вы можете просмотреть товары других категорий",
  "notYetUseCode": "Не использовано промокодов",
  "guest_Login": "Вход как гость",
  "billing_and_shipping": "Счет и адрес доставки совпадают",
  "select_coupon": "Выбор купона",
  "select_gift": "Выбор подарка",
  "currentUseCode": "Использованные промокоды",
  "shipping_refresh": "Обновить список",
  "Shipping_details": "Адрес доставки",
  "MyAccount_Newsletter": "Подписка",
  "MyAccount_Profile": "Досье",
  "MyAccount_Wishlist": "Список Желаний",
  "See_all": "все",
  "MyAccount_History": "история заказов",
  "bind_microsoft": "Связать с Microsoft",
  "bind_twitter": "Связать с Twitter",
  "bind_facebook": "Связать с Facebook",
  "bind_wechat_code": "Код WeChat",
  "bind_wechat": "Связать с WeChat",
  "bind_google": "Связать с Google",
  "Wishlist_Empty": "Нет списка желаемого",
  "discount_post_fee": "Скидка на почтовые расходы",
  "ORDER_PART_PAID": "Частичная оплата",
  "claimCouponeSuccess": "{name} успешно получен",
  "discount_kou": "{скидка} вычитать",
  "claimCoupone": "забрать",
  "cartPreviewSafety_messageinfo": "Безопасная и быстрая доставка до вашего адреса",
  "Order_No": "Номер заказа",
  "cartPreviewSafety": "Безопасная доставка",
  "Shipping": "Доставка",
  "MyAccount_MyShippingDetails_Street": "Улица",
  "MyAccount_MyShippingDetails_HouseNumber": "Номер дома",
  "Shipping_title": "Адрес доставки",
  "Offline_payment": "Оплата в офлайн",
  "shopName": "Название магазина",
  "Social": "Социальная сеть",
  "SERVICE": "услуга",
  "onlineContact": "онлайн-контакт",
  "confirm": "подтвердить",
  "closeOrder": "Отменить заказ",
  "closeOrderContext": "Вы уверены, что хотите отменить заказ?",
  "Message_Read": "прочитано",
  "close.order.success": "Заказ успешно отменен",
  "shippingAddress": "Адрес доставки",
  "Message": "Сообщение",
  "Message_Empty_Title": "Ваше сообщение пусто",
  "MyAccount_Message": "Сообщение",
  "Message_Empty": "Нет сообщений",
  "payment_order_note": "Примечание к заказу",
  "go_to_see_prepid": "Нажмите здесь, чтобы просмотреть неоплаченные заказы",
  "operate": "Операция",
  "removeCartItemContext": "Вы уверены, что хотите удалить {title}?",
  "shippingItemQty": "Количество товаров для доставки",
  "removeCartItem": "Удалить товар",
  "shippingInfo": "Информация о доставке",
  "Distributor_success": "Уже успешно для дистрибьютора",
  "Distributor_apply": "Применять как дистрибьютор",
  "Distributor_Details": "Дистрибьютор",
  "DistributorSataus": "Статус",
  "Distributor_Details_Empty": "Нет дистрибьюторов пока",
  "distributor.status.4": "Был аннулирован",
  "distributor.status.1": "Не пройден проверку",
  "Distributor_copy_url": "Скопировать ссылку дистрибьютора",
  "Order_Time": "Время оформления заказа",
  "Order_User": "Пользователь, сделавший заказ",
  "Distributor_copy_success": "Скопировано успешно",
  "distributor.status.3": "Уже урегулировано",
  "MyAccount_Distributor": "Дистрибьютор",
  "MyAccoubnt_Set_Distributor": "Применять как дистрибьютор",
  "distributor.status.2": "В ожидании урегулирования",
  "DistributorAmount": "Комиссия",
  "Distributor_shenheshibai": "Дистрибьютор не прошел проверку",
  "Distributor_shenhezhong": "Дистрибьютор находится на проверке",
  "Distributor_Order_Empty": "Нет заказов дистрибьюторов",
  "NE": "Нигер",
  "DJ": "Джибути",
  "KP": "Корейская Народно-Демократическая Республика",
  "US": "Соединенные Штаты",
  "LC": "Сент-Люсия",
  "NL": "Нидерланды",
  "CD": "Демократическая Республика Конго",
  "IS": "Исландия",
  "MA": "Марокко",
  "GH": "Гана",
  "KR": "Республика Корея",
  "MK": "Македония",
  "HT": "Гаити",
  "PF": "Французская Полинезия",
  "GA": "Габон",
  "TD": "Чад",
  "LB": "Ливан",
  "CG": "Конго",
  "KG": "Киргизия",
  "TA": "Тристан-да-Кунья",
  "KW": "Кувейт",
  "TL": "Восточный Тимор",
  "IN": "Индия",
  "NO": "Норвегия",
  "NG": "Нигерия",
  "AQ": "Антарктида",
  "LY": "Ливия",
  "NI": "Никарагуа",
  "TT": "Тринидад и Тобаго",
  "HM": "Херд и Макдональд",
  "PY": "Парагвай",
  "BA": "Босния и Герцеговина",
  "JP": "Япония",
  "MD": "Молдова",
  "MT": "Мальта",
  "RE": "Реюньон",
  "UG": "Уганда",
  "SB": "Соломоновы острова",
  "SL": "Сьерра-Леоне",
  "CV": "Кабо-Верде",
  "SD": "Судан",
  "FO": "Фарерские острова",
  "ZA": "Южно-Африканская Республика",
  "TR": "Турция",
  "FK": "Фолклендские острова",
  "PA": "Панама",
  "GF": "Французская Гвиана",
  "TJ": "Таджикистан",
  "NC": "Новая Каледония",
  "PM": "Сен-Пьер и Микелон",
  "NU": "Ниуэ",
  "AO": "Ангола",
  "VN": "Вьетнам",
  "GN": "Гвинея",
  "MW": "Малави",
  "BY": "Беларусь",
  "IM": "Остров Мэн",
  "BI": "Бурунди",
  "BS": "Багамские Острова",
  "CK": "Острова Кука",
  "MH": "Маршалловы Острова",
  "CR": "Коста-Рика",
  "HK": "Гонконг, САР Китая",
  "AD": "Андорра",
  "BN": "Бруней-Даруссалам",
  "SN": "Сенегал",
  "AE": "Объединенные Арабские Эмираты",
  "GI": "Гибралтар",
  "CA": "Канада",
  "AX": "Оландские острова",
  "UY": "Уругвай",
  "WF": "Уоллис и Футуна",
  "GM": "Гамбия",
  "SO": "Сомали",
  "RU": "Россия",
  "PL": "Польша",
  "FM": "Микронезия, Федеративные штаты",
  "ET": "Эфиопия",
  "EE": "Эстония",
  "SK": "Словакия",
  "AS": "Американское Самоа",
  "ZM": "Замбия",
  "AL": "Албания",
  "AT": "Австрия",
  "VA": "Ватикан",
  "TW": "Тайвань, провинция Китая",
  "BD": "Бангладеш",
  "AR": "Аргентина",
  "EH": "Западная Сахара",
  "MO": "Специальный административный регион Китая Макао",
  "MV": "Мальдивы",
  "GU": "Гуам",
  "AW": "Аруба",
  "AI": "Ангилья",
  "CL": "Чили",
  "IL": "Израиль",
  "GD": "Гренада",
  "WS": "Самоа",
  "SE": "Швеция",
  "GP": "Гваделупа",
  "YE": "Йемен",
  "GT": "Гватемала",
  "BG": "Болгария",
  "SJ": "Шпицберген и Ян-Майен",
  "CO": "Колумбия",
  "LS": "Лесото",
  "LV": "Латвия",
  "UM": "Внешние малые острова США",
  "MX": "Мексика",
  "DO": "Доминиканская Республика",
  "PE": "Перу",
  "HN": "Гондурас",
  "TC": "Теркс и Кайкос",
  "VI": "Виргинские острова, США",
  "FJ": "Фиджи",
  "MP": "Северные Марианские острова",
  "AC": "остров Вознесения",
  "NA": "Намибия",
  "SZ": "Свазиленд",
  "RW": "Руанда",
  "BH": "Бахрейн",
  "KN": "Сент-Китс и Невис",
  "TN": "Тунис",
  "AF": "Афганистан",
  "VG": "Виргинские острова, Британские",
  "KE": "Кения",
  "PK": "Пакистан",
  "GL": "Гренландия",
  "SY": "Сирия",
  "CU": "Куба",
  "RS": "Сербия",
  "BF": "Буркина-Фасо",
  "BM": "Бермуды",
  "BZ": "Белиз",
  "SV": "Сальвадор",
  "CN": "Китай",
  "MF": "Сен-Мартен",
  "NF": "Норфолк",
  "MZ": "Мозамбик",
  "LU": "Люксембург",
  "TO": "Тонга",
  "GR": "Греция",
  "SI": "Словения",
  "PW": "Палау",
  "TZ": "Танзания",
  "IR": "Иран",
  "GG": "Гернси",
  "SM": "Сан-Марино",
  "TF": "Французские Южные и Антарктические территории",
  "PS": "Палестина",
  "SC": "Сейшельские острова",
  "BT": "Бутан",
  "JM": "Ямайка",
  "BR": "Бразилия",
  "CH": "Швейцария",
  "SH": "Остров Святой Елены",
  "HU": "Венгрия",
  "TM": "Туркменистан",
  "LT": "Литва",
  "MC": "Монако",
  "LI": "Лихтенштейн",
  "LR": "Либерия",
  "GE": "Грузия",
  "SA": "Саудовская Аравия",
  "GB": "Великобритания",
  "VE": "Венесуэла",
  "MU": "Маврикий",
  "HR": "Хорватия",
  "SR": "Суринам",
  "CM": "Камерун",
  "IQ": "Ирак",
  "BO": "Боливия",
  "MN": "Монголия",
  "DZ": "Алжир",
  "TK": "Токелау",
  "MG": "Мадагаскар",
  "YT": "Майотта",
  "CC": "Кокосовые о-ва",
  "LA": "Лаос",
  "PT": "Португалия",
  "QA": "Катар",
  "AN": "Netherlands Antilles",
  "PN": "Pitcairn",
  "ES": "Испания",
  "VC": "Сент-Винсент и Гренадины",
  "AU": "Австралия",
  "CX": "Остров Рождества",
  "KM": "Коморские о-ва",
  "MR": "Мавритания",
  "FR": "Франция",
  "SG": "Сингапур",
  "BV": "остров Буве",
  "PH": "Филиппины",
  "CY": "Кипр",
  "TV": "Тувалу",
  "CF": "Центральноафриканская Республика",
  "EC": "Эквадор",
  "GW": "Гвинея-Бисау",
  "IE": "Ирландия",
  "LK": "Шри-Ланка",
  "ER": "Эритрея",
  "GQ": "Экваториальная Гвинея",
  "NP": "Непал",
  "BE": "Бельгия",
  "GY": "Гайана",
  "DK": "Дания",
  "MQ": "Мартиника",
  "UZ": "Узбекистан",
  "CI": "Кот-д’Ивуар",
  "ID": "Индонезия",
  "BJ": "Бенин",
  "ST": "Сан-Томе и Принсипи",
  "KH": "Камбоджа",
  "KZ": "Казахстан",
  "MS": "Монтсеррат",
  "TH": "Таиланд",
  "FI": "Финляндия",
  "ML": "Мали",
  "AM": "Армения",
  "IT": "Италия",
  "NR": "Науру",
  "PG": "Папуа – Новая Гвинея",
  "ZW": "Зимбабве",
  "JO": "Иордания",
  "OM": "Оман",
  "ME": "Черногория",
  "JE": "Джерси",
  "NZ": "Новая Зеландия",
  "VU": "Вануату",
  "DE": "Германия",
  "CZ": "Чехия",
  "DM": "Доминика",
  "KY": "Каймановы острова",
  "BW": "Ботсвана",
  "RO": "Румыния",
  "PR": "Пуэрто-Рико",
  "AZ": "Азербайджан",
  "IO": "Британская территория в Индийском океане",
  "UA": "Украина",
  "TG": "Того",
  "MY": "Малайзия",
  "AG": "Антигуа и Барбуда",
  "EG": "Египет",
  "GS": "Южная Джорджия и Южные Сандвичевы острова",
  "MM": "Мьянма (Бирма)",
  "BB": "Барбадос",
  "KI": "Кирибати",
  "All_Country": "Все",
  "post_state_country": "Доставка: {country} {state} {postFee}",
  "zhichiDeliveryCountry": "Доставка в",
  "ShippingFee": "Стоимость доставки",
  "reviewOutOf": "{рейтинг} звезд, из 5 звёзд",
  "product.pifa.label": "Купить от {startnum} до {endnum} штук",
  "product.pifa.type.1": "Скидка",
  "Write_a_review": "Написать отзыв",
  "BasedOnTotalReviews": "Основано на {total} отзывах",
  "product.wholesale": "Оптовая цена",
  "reviewMostRecent": "Самые новые отзывы",
  "product.pifa.type.2": "Цена за штуку",
  "product.num.danwei": "штук",
  "good.shoppingDateLabel": "Дата отправки",
  "good.shippingPeriod": "Дней до отправки",
  "emailError": "Неверный формат адреса электронной почты",
  "addressNote": "Примечание к адресу",
  "Concactus": "Контакт",
  "addressMessage": "Проверьте правильность своего адреса. Мы не можем изменить адрес после оформления заказа.",
  "showOrderSummary": "Сводка заказа",
  "payment_method": "Способ оплаты",
  "emailNotNullError": "Адрес электронной почты не может быть пустым.",
  "orderCreateLoading": "Заказ создается...",
  "emailNote": "Контакт",
  "emailMessage": "Проверьте правильность своего адреса электронной почты. Мы отправим вам подтверждение заказа.",
  "payment_method_message": "Все операции совершаются в безопасном и зашифрованном режиме.",
  "go_buy_goods": "Продолжить покупки",
  "tap_cancel_order": "Нажмите здесь, чтобы отменить заказ",
  "order_review": "Отзыв о заказе",
  "Add_new_address": "Добавить новый адрес",
  "promo_code_type_3": "Полный купон",
  "IdCardNotNull": "Пожалуйста, заполните информацию о реальном имени",
  "UploadVideo": "Загрузить видео",
  "video": "Видео",
  "UploadImage": "Загрузить изображение",
  "uploadImageing": "Загрузка...",
  "BillingInfoNotNull": "Информация о счете не полная",
  "promo_code_type_2": "Ваучер",
  "UploadError": "Ошибка загрузки",
  "promo_code_type_4": "Купон на снижение стоимости доставки",
  "image": "Картина",
  "paymentMethodNotNull": "Пожалуйста, выберите способ оплаты",
  "promo_code_type_1": "Купон на скидку",
  "shippingInfoNotNull": "Информация о доставке не полная",
  "reviewDetail": "Детали оценки",
  "DeliveryCountry": "Область доставки",
  "prompt_error": "Предупреждение об ошибке",
  "save_review_success": "Отзыв сохранен успешно",
  "ORDER_COMPLETED": "Завершен",
  "crate_after_sales": "Создать послепродажный сервис",
  "Thank_You_Order": "Спасибо за ваш заказ!",
  "Thank_You_Order_sub": "В ближайшее время мы начнем обработку Вашего заказа. Вы получите электронное письмо с информацией об обработке заказа.",
  "BootomCookieContext": "Этот сайт использует cookies, чтобы помочь сайту функционировать и понять, как вы с ним взаимодействуете. Мы используем эти cookies, чтобы предоставить вам более персонализированный пользовательский опыт. Если вы продолжаете использовать этот сайт, мы счи",
  "order_reivice_message": "Вы действительно получили товар?",
  "order_reivice_btn": "Подтвердить получение",
  "order_reivice_label": "Получение заказа",
  "order_reivice_success": "Получение заказа подтверждено",
  "collpase_show": "Показать больше",
  "collpase_hide": "Скрыть",
  "CouponCode": "Код купона",
  "wechatPayScannerCode": "Используйте WeChat для сканирования QR-кода и произведения оплаты",
  "processing": "Обработка售后",
  "finished": "售后已完成",
  "login.showPrice": "Посмотреть цену после входа в систему",
  "After_Sales_Unknown": "未知状态售后",
  "order_payment_list_null": "Нет ожидающих оплаты заказов",
  "Cancel": "Отмена",
  "thankyou_concat": "Если у вас есть какие-либо вопросы, пожалуйста, свяжитесь с нами"
}